define(function(require, exports, module) {
	var inherit = require('inherit');
	var Emitter = require('Emitter');
	var $ = require('jquery');
	var app = require('Cloud/Application/app');
	var RB_PREVIEW = (app.getParam('RB_SLOT_PARAM') || '').split('=')[1];
	var ADQ_TIMEOUT = app.getParam('ADQ_TIMEOUT');

	var ADQRequest = inherit(Emitter, {
		name: 'ADQRequest',

		constructor: function ADQRequest(settings) {
			settings || (settings = {});

			this._slotId = settings.slotId;
			this._siteZone = settings.siteZone;
			this._dataType = settings.dataType || 'html';
		},

		send: function() {
			return new Promise(function(resolve, reject) {
				var params = {};

				params.q = [this._slotId];
				params.preview = RB_PREVIEW;
				var sz = this._siteZone;
				var slotKey = this._slotId + (isFinite(sz) ? 'sz' + sz : '');

				var radar = RADAR.group('app_adq-request');

				radar
					.timeEnd('rb_start_all')
					.timeEnd('rb_start_slot-' + this._slotId);

				var adqRequestParams = {
					url: '//ad.mail.ru/adq/',
					dataType: 'jsonp',
					data: params,

					success: function(data){
						var requestedData;

						if (Array.isArray(data) && data.length){
							for (var i = 0; i < data.length; i++){
								var slotData = data[i];

								if (slotData.slot == this._slotId) {
									requestedData = slotData.html;
									break;
								}
							}
						}

						if (!requestedData) {
							reject(new Error("No Data"));

							return;
						}

						if (this._dataType === 'json') {
							try {
								requestedData = JSON.parse(requestedData);
							} catch(e) {
								reject(new Error('Unsupported format'));
							}
						}

						resolve(requestedData);

						radar
							.timeEnd('rb_success_all')
							.timeEnd('rb_success_slot-' + this._slotId);

						radar.send();
					}.bind(this),

					error: function(jqXHR, textStatus, errorThrown){
						if (textStatus === 'timeout'){
							radar
								.timeEnd('rb_timeout_all')
								.timeEnd('rb_timeout_slot-' + this._slotId);

						} else {
							radar
								.timeEnd('rb_error_all')
								.timeEnd('rb_error_slot-' + this._slotId);
						}

						reject(textStatus);
						radar.send();
					}.bind(this)

				};

				if (ADQ_TIMEOUT) {
					adqRequestParams.timeout = ADQ_TIMEOUT;
				}

				$.ajax(adqRequestParams);
			}.bind(this));
		}
	});

	module.exports = ADQRequest;
});
